export enum InstallmentType {
  NOT_SET = "Not Set",
  EQUAL_PAYMENTS = "Equal Payments",
  FIXED_AMOUNTS = "Fixed Amounts",
}
